export default "__VITE_ASSET__DUAtsPuc__"